module.exports = __webpack_public_path__ + "img/dianban.prt.e78fef9a.jpg";